import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'

export const useActiveItems = () => {
  const mediaItems = useSelector(projectDataSelectors.mediaItems)
  const audioItems = useSelector(projectDataSelectors.multilineAudios)
  const activeTimelineMediaItems = useSelector(editorSelectors.activeMediaItems)
  const activeTimelineAudioItems = useSelector(editorSelectors.activeAudioItems)

  const activeMediaItems = useMemo(() => {
    return mediaItems.filter(item =>
      activeTimelineMediaItems.some(activeItem => activeItem.id === item.id)
    )
  }, [mediaItems, activeTimelineMediaItems])

  const activeAudioItems = useMemo(() => {
    return audioItems.filter(item =>
      activeTimelineAudioItems.some(activeItem => activeItem.id === item.id)
    )
  }, [audioItems, activeTimelineAudioItems])
  return { activeMediaItems, activeAudioItems }
}
